export const ADMIN_TOKEN_STORE_NAME = 'bp-admin';
export const ADMIN_ONBOARDING_STEP = 'bp-onboarding-step';
